<template>
  <div>
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          label="Название"
          :required="true"
          placeholder="Введите название конструктива"
          :value="formData.work_set_name || ''"
          @change_input="value => onChange('work_set_name', value)"
        />
      </div>
      
      <div class="form__item">
        <CustomSelect
          :options="unitOptions"
          label="Ед.измерения"
          optionValueKey="unit_id"
          optionLabelKey="unit_name"
          :required="true"
          placeholder="Выберите единицу измерения"
          :value="formData.unit_id || ''"
          @change="(value, row) => onChange('unit_id', value, row)"
        />
      </div>
      
      <div class="form__item">
        <CustomInput
          label="Формула"
          :required="true"
          placeholder="Введите формулу"
          :value="formData.formula || ''"
          @change_input="value => onChange('formula', value)"
        />
      </div>
      
      <CustomModalFooter
        :btn-loading="loading"
        :on-submit="onSubmit"
        submit-btn-text="Добавить конструктив"
      />
    </q-form>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import CustomInput from '@/components/form/CustomInput'
import CustomSelect from '@/components/form/CustomSelect'
import CustomModalFooter from '@/components/modal/modals/modal-footer'

import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'
import { getUnits, addWorkSet } from '@/views/PackageEntry/services'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  closeModal: {
    type: Function,
    default: () => {}
  }
})

const { showSucceedSnackbar } = useCustomSnackbar()

const loading = ref(false)
const formData = ref({
  work_set_name: '',
  unit_id: '',
  formula: ''
})

const { data: unitsData } = useQuery({
  queryKey: ['units'],
  queryFn: () => getUnits()
})

const unitOptions = computed(() => unitsData.value?.data || [])

const onChange = (field, value, row) => {
  formData.value[field] = value
}

const closeModal = () => {
  props.closeModal()
}

const onSubmit = async () => {
  loading.value = true
  
  const res = await addWorkSet(formData.value)
  if (!res) {
    loading.value = false
    return
  }
  showSucceedSnackbar()
  
  if (props.data?.onClose) {
    props.data.onClose(res.data?.[0]?.work_set__add)
  }
  
  closeModal()
  loading.value = false
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__item {
    display: flex;
    flex-direction: column;
  }
}
</style>